import { render } from "./open-github-pages.vue?vue&type=template&id=68632b46"
import script from "./open-github-pages.vue?vue&type=script&lang=js"
export * from "./open-github-pages.vue?vue&type=script&lang=js"

import "./open-github-pages.vue?vue&type=style&index=0&id=68632b46&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__